/* eslint-disable react/prop-types */
// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React base styles
import typography from "assets/theme/base/typography";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftProgress from "components/SoftProgress";
import { Margin } from "@mui/icons-material";
import SoftAvatar from "components/SoftAvatar";

function ReportsBarChartItem({ color, icon, label, progress,variables,loading }) {
  const { size } = typography;

  const hasSpecialDelimiter = typeof progress.content === 'string' && progress.content.includes('//');
  let firstPart = progress.content;
  let secondPart = '';

  // Eğer "//" varsa, string'i böl ve ayır
  if (hasSpecialDelimiter) {
    const parts = progress.content.split('//');
    firstPart = parts[0];
    secondPart = parts[1];
  }


  return (
    <SoftBox width="100%" mb={2} bgColor="#f7f8f9" p={1} borderRadius="1rem" isLoading={loading}>
      <SoftBox display="flex" alignItems="flex-start" mb={1}>
        <SoftAvatar
          color={icon.color}
          size={size.icon}
          variant="rounded"
          src={icon.src}
          isLoading={loading}

        >

        </SoftAvatar>
        <div style={{ display: "flex", flexDirection: "column" }}>
        <SoftTypography
          variant="caption"
          textTransform="capitalize"
          fontWeight="medium"
          color="text"
          //height="2rem"
          width="100%"
          ml={1}
        
        >
          {label}
        </SoftTypography>
        
        <SoftTypography
          variant="caption"
          textTransform="capitalize"
          fontWeight="regular"
          color="text"
          height="1rem"
          width="100%"
          ml={1}
          mt={1}
        >
          {variables.unvan}
        </SoftTypography>

        <SoftTypography
          variant="caption"
          textTransform="capitalize"
          fontWeight="regular"
          color="secondary"
          height="1rem"
          width="100%"
          fontSize="0.6rem"
          ml={1}
          mt={0.1}
        >
          {variables.mudurluk}
        </SoftTypography>
        </div>
      </SoftBox>
      <SoftBox mt={1}>
        <SoftTypography variant="h4" fontWeight="bold" color={color}>
          {firstPart}
          {secondPart && (
            <span style={{ color: "rgb(181 191 205)", fontSize: "15px", margin: "4px" }}>
              / {"100"}
            </span>
          )}
        </SoftTypography>
        <SoftBox width="75%" mt={0.5}>
          <SoftProgress value={progress.percentage} color={color} />
        </SoftBox>
        {!String(progress.content).includes('%') && (
          <SoftTypography variant="button" color="secondary">
            {progress.percentage ? String("%" + progress.percentage).slice(0, 4) : ""}

          </SoftTypography>
        )}

        <SoftBox style={{ display: "flex", width: "100%", flexDirection: "row", justifyContent: "space-around" }} pl={2} >
          <SoftBox mt={2}  lineHeight={0} display="grid" sx={{ width: { xs: "160%", sm: "auto" }, textAlign: { xs: "center", sm: "center" } }}>
            <SoftTypography variant="button" fontWeight="medium" color="#434343" >
              {variables.disiplin}
            </SoftTypography>

            <SoftTypography
              variant="button"
              fontWeight="regular"
              sx={{ fontSize: { xs: "11px", sm: "14px" }, color: { xs: "#656464 !important", sm: "#70747a" } }}
              color={{ xs: "#7b7c7d !important", sm: "#70747a" }}
              textTransform="capitalize"
              display={{ xs: "unset", sm: "unset" }}

            >
              {variables.disiplin_deger + " Disiplin"}
            </SoftTypography>
          </SoftBox>
          <SoftBox mt={2} lineHeight={0} display="grid" sx={{ width: { xs: "160%", sm: "auto" }, textAlign: { xs: "center", sm: "center" } }}>
            <SoftTypography variant="button" fontWeight="medium" color="#434343" >
              {variables.mesai_uyum}
            </SoftTypography>

            <SoftTypography
              variant="button"
              fontWeight="regular"
              sx={{ fontSize: { xs: "11px", sm: "14px" }, color: { xs: "#656464 !important", sm: "#70747a" } }}
              color={{ xs: "#7b7c7d !important", sm: "#70747a" }}
              textTransform="capitalize"
              display={{ xs: "unset", sm: "unset" }}

            >
              {variables.mesai_uyum_deger + " Mesai Uyum"}
            </SoftTypography>
          </SoftBox>
          <SoftBox mt={2} lineHeight={0} display="grid" sx={{ width: { xs: "160%", sm: "auto" }, textAlign: { xs: "center", sm: "center" } }}>
            <SoftTypography variant="button" fontWeight="medium" color="#434343" >
              {variables.saglik_raporu}
            </SoftTypography>

            <SoftTypography
              variant="button"
              fontWeight="regular"
              sx={{ fontSize: { xs: "11px", sm: "14px" }, color: { xs: "#656464 !important", sm: "#70747a" } }}
              color={{ xs: "#7b7c7d !important", sm: "#70747a" }}
              textTransform="capitalize"
              display={{ xs: "unset", sm: "unset" }}

            >
              {variables.saglik_raporu_deger + " Rapor"}
            </SoftTypography>
          </SoftBox>
          <SoftBox mt={2} lineHeight={0} display="grid" sx={{ width: { xs: "160%", sm: "auto" }, textAlign: { xs: "center", sm: "center" } }}>
            <SoftTypography variant="button" fontWeight="medium" color="#434343" >
              {variables.performans}
            </SoftTypography>

            <SoftTypography
              variant="button"
              fontWeight="regular"
              sx={{ fontSize: { xs: "11px", sm: "14px" }, color: { xs: "#656464 !important", sm: "#70747a" } }}
              color={{ xs: "#7b7c7d !important", sm: "#70747a" }}
              textTransform="capitalize"
              display={{ xs: "unset", sm: "unset" }}

            >
              {variables.performans_deger + " Üretim"}
            </SoftTypography>
            
          </SoftBox>
          <SoftBox mt={2} lineHeight={0} display="grid" sx={{ width: { xs: "160%", sm: "auto" }, textAlign: { xs: "center", sm: "center" } }}>
            <SoftTypography variant="button" fontWeight="medium" color="#434343" >
              {variables.degerlendirme}
            </SoftTypography>

            <SoftTypography
              variant="button"
              fontWeight="regular"
              sx={{ fontSize: { xs: "11px", sm: "14px" }, color: { xs: "#656464 !important", sm: "#70747a" } }}
              color={{ xs: "#7b7c7d !important", sm: "#70747a" }}
              textTransform="capitalize"
              display={{ xs: "unset", sm: "unset" }}

            >
              {variables.degerlendirme_deger + " Değerlendirme"}
            </SoftTypography>
          </SoftBox>
        </SoftBox>



      </SoftBox>
    </SoftBox>
  );
}

// Setting default values for the props of ReportsBarChartItem
ReportsBarChartItem.defaultProps = {
  color: "dark",
};

// Typechecking props for the ReportsBarChartItem
ReportsBarChartItem.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.shape({
    color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"])
      .isRequired,
    component: PropTypes.node.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  progress: PropTypes.shape({
    content: PropTypes.string.isRequired,
    percentage: PropTypes.number.isRequired,
  }).isRequired,
};

export default ReportsBarChartItem;
